import { useAppDispatch, useAppSelector } from './redux';
import {
  toggleNavbar,
  closeNavbar,
  openNavbar,
  setLoading,
  setTheme,
  addNotification,
  removeNotification,
  clearNotifications,
} from '../store/slices/uiSlice';

export const useUI = () => {
  const dispatch = useAppDispatch();
  const { isNavbarOpen, isLoading, theme, notifications } = useAppSelector(
    (state) => state.ui
  );

  const toggleNav = () => {
    dispatch(toggleNavbar());
  };

  const closeNav = () => {
    dispatch(closeNavbar());
  };

  const openNav = () => {
    dispatch(openNavbar());
  };

  const setAppLoading = (loading: boolean) => {
    dispatch(setLoading(loading));
  };

  const changeTheme = (newTheme: 'light' | 'dark') => {
    dispatch(setTheme(newTheme));
  };

  const showNotification = (notification: {
    type: 'success' | 'error' | 'warning' | 'info';
    message: string;
    duration?: number;
  }) => {
    const id = Date.now().toString();
    dispatch(addNotification({ ...notification, id }));
    
    // Auto remove notification after duration
    if (notification.duration !== 0) {
      setTimeout(() => {
        dispatch(removeNotification(id));
      }, notification.duration || 5000);
    }
  };

  const hideNotification = (id: string) => {
    dispatch(removeNotification(id));
  };

  const clearAllNotifications = () => {
    dispatch(clearNotifications());
  };

  return {
    isNavbarOpen,
    isLoading,
    theme,
    notifications,
    toggleNav,
    closeNav,
    openNav,
    setAppLoading,
    changeTheme,
    showNotification,
    hideNotification,
    clearAllNotifications,
  };
};
